import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, interval, ReplaySubject, Subject, Subscription, timer } from 'rxjs';
import { IssueStatusDialogComponent } from 'src/app/lib/issue/components/dialog/issue-status-dialog/issue-status-dialog.component';
import { NewsfeedNotification } from '../../classes';
import { NewsfeedNotificationObservables } from '../../globals';
import { NewsfeedService } from '../../services/newsfeed.service';

@Component({
  selector: 'app-newsfeed',
  templateUrl: './newsfeed.component.html',
  styleUrls: ['./newsfeed.component.css']
})
export class NewsfeedComponent implements OnDestroy, OnInit {

  private _autoRefresh = new BehaviorSubject<boolean>(false);
  autoRefresh$ = this._autoRefresh.asObservable();

  private _initializing = new BehaviorSubject<boolean>(true);
  initializing$ = this._initializing.asObservable();

  private _tickSubject = new Subject();

  refreshSeconds = 5;

  private _timerSub: Subscription = null;
  private _subscriptions: Subscription[] = [];

  constructor(
    public newsfeedService: NewsfeedService,
    private _router: Router,
    private _dialog: MatDialog
  ) { }

  loadMore() {
    this.newsfeedService.loadMoreChanges();
  }

  newsfeedNotificationClicked(notification: NewsfeedNotification) {
    this.newsfeedService.getAuditStatus(notification.observable, notification.identifier).subscribe((result) => {
      switch (notification.observable) {
        case NewsfeedNotificationObservables.IssueChange:
        case NewsfeedNotificationObservables.IssueCreation:
        case NewsfeedNotificationObservables.IssueDeletion:
          this._dialog.open(IssueStatusDialogComponent, {
            panelClass: 'no-padding-dialog-container',
            data: [result]
          });
          break;
      }
    });
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    this._subscriptions.push(
      timer(3000).subscribe(() => this.newsfeedService.loadInitialChanges().subscribe(() => this._initializing.next(false))),
      this.newsfeedService.subscriptionChange$.subscribe(() => {
        this._autoRefresh.next(true);
      }),
      this.autoRefresh$.subscribe((value: boolean) => {
        if (this._timerSub) this._timerSub.unsubscribe();
        if (value) {
          this.refreshSeconds = 5;
          this._timerSub = interval(1000).subscribe(() => this._tickSubject.next());
        }
      }),
      this._tickSubject.subscribe(() => {
        this.refreshSeconds--;
        if (this.refreshSeconds === 0) this.reload();
      })
    );
  }

  reload() {
    this.newsfeedService.loadInitialChanges();
    this._autoRefresh.next(false);
  }

}
